import './assets/form-checkbox-group.css';const o = {
  "form-input-control": "_form-input-control_1o27r_1",
  "form-input-control--is-flag": "_form-input-control--is-flag_1o27r_34",
  "form-input-control--is-bordered": "_form-input-control--is-bordered_1o27r_45",
  "form-input-control--is-label-full-width": "_form-input-control--is-label-full-width_1o27r_51",
  "form-input-control--is-square": "_form-input-control--is-square_1o27r_69",
  "form-input-control--size-sm": "_form-input-control--size-sm_1o27r_74",
  "form-input-control--is-invalid": "_form-input-control--is-invalid_1o27r_79",
  "form-input-control--with-label": "_form-input-control--with-label_1o27r_100",
  "form-input-control__signifier": "_form-input-control__signifier_1o27r_104",
  "form-input-control__control": "_form-input-control__control_1o27r_119",
  "form-input-control__icon": "_form-input-control__icon_1o27r_129",
  "form-input-control__label": "_form-input-control__label_1o27r_151",
  "form-input-control__label--with-signifier": "_form-input-control__label--with-signifier_1o27r_160",
  "form-multi-item": "_form-multi-item_1o27r_215",
  "form-multi-item__label": "_form-multi-item__label_1o27r_228",
  "form-multi-item__controls": "_form-multi-item__controls_1o27r_249"
};
export {
  o as s
};
